export default ({ request }) => ({
    materialAbnormalListApi(data = {}) {
      return request({
        url: '/financial/user/material/abnormal/list',
        method: 'post',
        data,
      })
    },
    materialAbnormalDetailApi(data = {}) {
      return request({
        url: '/financial/user/material/abnormal/detail',
        method: 'post',
        data,
      })
    },
    materialAbnormalItemListApi(data = {}) {
      return request({
        url: '/financial/user/material/abnormal/item/list',
        method: 'post',
        data,
      })
    },
    materialAbnormalDocistApi(data = {}) {
      return request({
        url: '/financial/user/material/abnormal/doc/list',
        method: 'post',
        data,
      })
    },
    materialAbnormalFinConfirmApi(data = {}) {
      return request({
        url: '/financial/user/material/abnormal/finConfirm',
        method: 'post',
        data,
      })
    },
  })
  